import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { Icon } from '@iconify/react';
const InfoIconTooltip = ({ title, variant = 'light', size = 'large', icon }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down(1280));
    const [open, setOpen] = useState(false);
    // Reset tooltip state when switching from mobile to desktop
    useEffect(() => {
        if (!isMobile) {
            setOpen(false);
        }
    }, [isMobile]);
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        // Auto-close on mobile after 2 seconds
        setOpen((prev) => !prev);
        if (isMobile) {
            setTimeout(() => setOpen(false), 2000);
        }
    };
    return (_jsx(Tooltip, { title: title, placement: isMobile ? 'auto' : 'right', arrow: true, open: open, onOpen: () => setOpen(true), onClose: () => setOpen(false), disableHoverListener: isMobile, disableFocusListener: isMobile, disableTouchListener: isMobile, slotProps: {
            tooltip: {
                sx: {
                    backgroundColor: variant === 'light' ? theme.palette.background.paper : theme.palette.grey[800],
                    color: variant === 'light' ? theme.palette.text.primary : theme.palette.common.white,
                    boxShadow: theme.customShadows.dropdown,
                    fontSize: size === 'small' ? '12px' : '14px',
                    fontWeight: 400
                }
            },
            arrow: {
                sx: {
                    color: variant === 'light' ? theme.palette.background.paper : theme.palette.grey[800]
                }
            }
        }, children: _jsx("span", { style: {
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: 32,
                minHeight: 32,
                padding: 6,
                margin: -6,
                cursor: 'pointer',
                borderRadius: 4
            }, onClick: handleClick, role: 'button', "aria-label": typeof title === 'string' ? title : 'More information', children: icon || (_jsx(Icon, { icon: 'hugeicons:information-circle', color: theme.palette.text.tertiary, fontSize: size === 'large' ? 20 : 12, style: { pointerEvents: 'none' } })) }) }));
};
export default InfoIconTooltip;
